/* KESTKAS - JS de la tienda: sin dependencias, compatible con el editor de temas */
(function () {
  "use strict";
  if (window.__KK_HOME__) { return; }
  window.__KK_HOME__ = 1;

  function safe(fn, name) {
    try { fn(); } catch (e) { console.warn("[kestkas] " + name + ":", e); }
  }
  function each(list, fn) { Array.prototype.forEach.call(list, fn); }

  /* ---- Selector "que cinta necesito" -------------------------
     Los paneles ya vienen en el HTML desde Liquid: aqui solo se
     alterna cual esta visible. Sin JS se ve el primero. */
  function initSelector(scope) {
    var roots = (scope || document).querySelectorAll("[data-kk-selector]");
    each(roots, function (root) {
      var tabs = root.querySelectorAll(".sel-item");
      var panels = root.querySelectorAll("[data-kk-panel]");
      if (!tabs.length || !panels.length) return;

      function select(i) {
        each(tabs, function (t, n) {
          var on = n === i;
          t.classList.toggle("is-on", on);
          t.setAttribute("aria-selected", on ? "true" : "false");
        });
        each(panels, function (p, n) { p.classList.toggle("is-on", n === i); });
      }

      each(tabs, function (t, i) {
        t.addEventListener("click", function () { select(i); });
      });
    });
  }

  /* ---- Galeria de la ficha de producto ----------------------- */
  function initGallery(scope) {
    var galleries = (scope || document).querySelectorAll("[data-kk-gallery]");
    each(galleries, function (g) {
      var main = g.querySelector("[data-kk-main] img");
      var thumbs = g.querySelectorAll("[data-kk-thumb]");
      if (!main || thumbs.length < 2) return;
      each(thumbs, function (t) {
        t.addEventListener("click", function () {
          var full = t.getAttribute("data-full");
          if (!full) return;
          main.setAttribute("src", full);
          main.removeAttribute("srcset");
          var alt = t.getAttribute("data-alt");
          if (alt) main.setAttribute("alt", alt);
          each(thumbs, function (o) { o.classList.remove("is-on"); });
          t.classList.add("is-on");
        });
      });
    });
  }

  /* ---- Apariciones al hacer scroll --------------------------- */
  var revealPending = [];
  function collectReveals(scope) {
    var els = Array.prototype.slice.call((scope || document).querySelectorAll(".kk .reveal:not(.in)"));
    if (!els.length) return;
    document.documentElement.classList.add("kk-anim-on");
    revealPending = revealPending.concat(els);
    checkReveals();
  }
  function checkReveals() {
    var vh = window.innerHeight || 800;
    for (var i = revealPending.length - 1; i >= 0; i--) {
      var r = revealPending[i].getBoundingClientRect();
      if (r.top < vh * 0.9 && r.bottom > 0) {
        revealPending[i].classList.add("in");
        revealPending.splice(i, 1);
      }
    }
  }
  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () { checkReveals(); ticking = false; });
  }

  /* ---- Acordeones: solo uno abierto -------------------------- */
  function initAccordions(scope) {
    var lists = (scope || document).querySelectorAll(".kk .faq-list, .kk .pdp-acc");
    each(lists, function (list) {
      var all = list.querySelectorAll("details");
      each(all, function (d) {
        d.addEventListener("toggle", function () {
          if (!d.open) return;
          each(all, function (o) { if (o !== d) o.open = false; });
        });
      });
    });
  }

  function boot(scope) {
    safe(function () { initSelector(scope); }, "selector");
    safe(function () { initGallery(scope); }, "galeria");
    safe(function () { collectReveals(scope); }, "reveals");
    safe(function () { initAccordions(scope); }, "acordeones");
  }

  function start() {
    boot(document);
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll);
    setTimeout(checkReveals, 220);
    setTimeout(checkReveals, 900);
    setTimeout(function () {
      each(document.querySelectorAll(".kk .reveal:not(.in)"), function (el) {
        el.classList.add("in");
      });
      revealPending = [];
    }, 6000);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start);
  } else {
    start();
  }

  document.addEventListener("shopify:section:load", function (e) { boot(e.target); });
})();
